import { SimpleGrid, Box, Text } from "@chakra-ui/react";
import CardDefault from "components/Cards/CardDefault/index";

export default function TiposContabilizacao() {
  return (
    <SimpleGrid columns={{ sm: 1, md: 2, lg: 3 }} gap="16px" mb="32px">
      <CardDefault>
        <Box>
          <Text fontWeight="bold" fontSize="16px" mb={2}>
            Provisão + Baixa por cliente
          </Text>
          <Text>
            Serão exportadas as provisões das vendas e recebimentos realizados
            por cliente, com data de competência dentro do período selecionado.
          </Text>
        </Box>
      </CardDefault>
      <CardDefault>
        <Box>
          <Text fontWeight="bold" fontSize="16px" mb={2}>
            Baixa sem provisão
          </Text>
          <Text>
            Serão exportados os recebimentos realizados desconsiderando os
            clientes, no período selecionado.
          </Text>
        </Box>
      </CardDefault>
      <CardDefault>
        <Box>
          <Text fontWeight="bold" fontSize="16px" mb={2}>
            Baixa por cliente
          </Text>
          <Text>
            Serão exportados os recebimentos realizados por clientes, no período
            selecionado.
          </Text>
        </Box>
      </CardDefault>
    </SimpleGrid>
  );
}
